import React, { forwardRef, useState, useContext } from "react";
import { GET_PERMISSIONS, GET_MODULES } from "../../utils/graphQL/queries";
import { DEL_PERMISSION } from "../../utils/graphQL/mutations";
import { useMutation } from "@apollo/client";
import ConfirmationDialog from "../common/confirmationDialog";
import Spinners from "../common/spinners";

export function DelPermission(props, ref) {
  const {
    onClose,
    open,
    title,
    setopenAlert,
    setalertMessage,
    setloader,
    setSeverity,
  } = props;

  const [deletePermission, { loading }] = useMutation(DEL_PERMISSION);
  const [errorMessage, seterrorMessage] = useState(false);
  const [spinners, setSpinners] = useState(false);

  const handleDelete = async () => {
    setSpinners(true);
    var id = ref.current.row ? ref.current.row.id : null;
    const response = await deletePermission({
      variables: { id: id },
      refetchQueries: [{ query: GET_MODULES }],
      awaitRefetchQueries: true,
    });
    if (response.data.deletePermission.deleted === true) {
      seterrorMessage(false);
      setSpinners(false);
      setopenAlert(true);
      setalertMessage("Permission has been Deleted");
      setSeverity(true);
    } else {
      seterrorMessage(true);
      setSpinners(false);
    }
    props.onClose();
    setloader(false);
  };

  return (
    <div>
      <ConfirmationDialog
        open={open}
        handleClose={onClose}
        handleSubmit={handleDelete}
        dialogTitle="Are you sure you want to Delete Permission ?"
      />
    </div>
  );
}

export default forwardRef(DelPermission);
